import { Component, Input } from '@angular/core';
import {
    UntypedFormControl,
    UntypedFormGroup,
    Validators,
} from '@angular/forms';
import { NumberFormatValidator } from 'src/app/shared/validators/number-format-validator';
import { WeightingValidator } from 'src/app/shared/validators/weighting-validator';
import { CostFunctionService } from '../../services/cost-function.service';
import { OrientationValidator } from 'src/app/shared/validators/orientation-validator';
import { AbstractTabComponent } from '../abstract-tab/abstract-tab.component';
import { environment } from 'src/environments/environment';
import { OrientationCostFunctionRow } from '../../models/orientation-cost-function-row';
import { NumberTranslateService } from 'src/app/shared/services/number-translate.service';

@Component({
    selector: 'app-orientation-tab-content',
    templateUrl: './orientation-tab-content.component.html',
    styleUrls: ['./orientation-tab-content.component.scss'],
    standalone: false,
})
export class OrientationTabContentComponent extends AbstractTabComponent {
    @Input() xAxisLabel: string;
    @Input() yAxisLabel: string;
    @Input() zAxisLabel: string;

    type: string = 'orientation';

    axisDecimalPoint: number = environment.costFunction.orientation.numDecimals;
    axisMinValue: number = environment.costFunction.orientation.min;
    axisMaxValue: number = environment.costFunction.orientation.max;

    constructor(
        costFunctionService: CostFunctionService,
        private numberService: NumberTranslateService
    ) {
        super(costFunctionService);
    }

    // Handle dropping an scene composition element in a dropzone
    drop($event: any) {
        const dragSceneElement = $event.item.data.sceneElement;

        const element = new OrientationCostFunctionRow();
        element.name = dragSceneElement.browserAndPhysicsLoadable.name;
        element.sceneElementId = dragSceneElement.id;

        const elementFormGroup = this.getElementFormGroup(element);
        this.rows.push(elementFormGroup);
        this.saveRow(elementFormGroup, this.sceneId, this.type);
    }

    // Get a form group for an existing element
    protected getElementFormGroup(element: OrientationCostFunctionRow) {
        const orientationValidators = [
            Validators.required,
            NumberFormatValidator.validateFormat,
            OrientationValidator.validateRange,
        ];
        return new UntypedFormGroup({
            name: new UntypedFormControl({
                value: element.name,
                disabled: false,
            }),
            sceneElementId: new UntypedFormControl(element.sceneElementId),
            angleX: new UntypedFormControl(
                this.numberService.translateNumber(
                    this.convertElementValueToString(
                        element.angleX,
                        this.axisDecimalPoint
                    )
                ),
                orientationValidators
            ),
            angleY: new UntypedFormControl(
                this.numberService.translateNumber(
                    this.convertElementValueToString(
                        element.angleY,
                        this.axisDecimalPoint
                    )
                ),
                orientationValidators
            ),
            angleZ: new UntypedFormControl(
                this.numberService.translateNumber(
                    this.convertElementValueToString(
                        element.angleZ,
                        this.axisDecimalPoint
                    )
                ),
                orientationValidators
            ),
            weight: new UntypedFormControl(
                {
                    value: this.numberService.translateNumber(
                        this.convertElementValueToString(
                            element.weight,
                            this.weightDecimalPoint
                        )
                    ),
                    disabled: false,
                },
                [
                    Validators.required,
                    NumberFormatValidator.validateFormat,
                    WeightingValidator.validateRange,
                ]
            ),
        });
    }
}
